// extracted by mini-css-extract-plugin
export default {"tooltipAnchor":"CrmOrganizationIndicator_tooltipAnchor__5OrKP","iconButton":"CrmOrganizationIndicator_iconButton__zNWel"};